module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"8\" height=\"8\" viewBox=\"0 0 8 8\">\n  <path d=\"M0 0v6h2v-6h-2zm4 0v6h2v-6h-2z\" transform=\"translate(1 1)\" />\n</svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./~/open-iconic/svg/media-pause.svg
 ** module id = 8
 ** module chunks = 0
 **/